export default (url, initObj) => {

	return fetch(url, initObj);
}
